import { Component, OnInit } from '@angular/core';
import { MemberService } from 'src/app/services/member.service';
import { NotificationService } from 'src/app/services/notification.service';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-add-subscription',
  templateUrl: './add-subscription.component.html',
  styleUrls: ['./add-subscription.component.scss']
})
export class AddSubscriptionComponent implements OnInit {
  public searchQuery: string = '';
  public searchResults: any[] = [];
  public selectedUser: any = null;
  public plans: any[] = [];
  public selectedPlanId: number = null;
  public subUntilDate: any = null;
  public loading: boolean = false;
  public searchLoading: boolean = false;

  private searchSubject = new Subject<string>();

  constructor(
    private _member: MemberService,
    private _notify: NotificationService
  ) {}

  ngOnInit() {
    this.loadPlans();
    this.searchSubject.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(q => {
      if (q.length >= 2) {
        this.doSearch(q);
      } else {
        this.searchResults = [];
      }
    });
  }

  loadPlans() {
    this._member.getPlans().subscribe(res => {
      this.plans = res;
    });
  }

  onSearchChange(q: string) {
    this.searchSubject.next(q);
  }

  doSearch(q: string) {
    this.searchLoading = true;
    this._member.searchUsers(q).subscribe(res => {
      this.searchResults = res;
      this.searchLoading = false;
    });
  }

  selectUser(user: any) {
    this.selectedUser = user;
    this.searchResults = [];
    this.searchQuery = user.first_name + ' ' + user.last_name + ' (' + user.email + ')';
  }

  clearUser() {
    this.selectedUser = null;
    this.searchQuery = '';
    this.searchResults = [];
  }

  submit() {
    if (!this.selectedUser || !this.selectedPlanId || !this.subUntilDate) {
      this._notify.showMessage('Please fill all fields', 'OK');
      return;
    }
    this.loading = true;
    const date = this.subUntilDate instanceof Date ? this.subUntilDate : new Date(this.subUntilDate);
    const dateStr = date.toISOString().split('T')[0];
    this._member.createManualSubscription(this.selectedUser.id, this.selectedPlanId, dateStr).subscribe(
      res => {
        this._notify.showMessage('Subscription created successfully', 'OK');
        this.loading = false;
        this.selectedUser = null;
        this.searchQuery = '';
        this.selectedPlanId = null;
        this.subUntilDate = null;
      },
      err => {
        this._notify.showMessage('Error creating subscription', 'OK');
        this.loading = false;
      }
    );
  }
}
